import React from "react";
import EMICalculator from "./EMICalculator";

const InputArea = ({
  inputText,
  setInputText,
  onSendMessage,
  onKeyPress,
  isEmiCalculatorOpen,
  setIsEmiCalculatorOpen,
  loanAmount,
  setLoanAmount,
  interestRate,
  setInterestRate,
  tenureYears,
  setTenureYears,
  emiValue,
  totalInterest,
  disabled = false,
  placeholder = "Type your message...",
  showQuickActions = false
}) => {
  return (
    <>
      {isEmiCalculatorOpen && (
        <EMICalculator
          isOpen={isEmiCalculatorOpen}
          onClose={() => setIsEmiCalculatorOpen(false)}
          loanAmount={loanAmount}
          setLoanAmount={setLoanAmount}
          interestRate={interestRate}
          setInterestRate={setInterestRate}
          tenureYears={tenureYears}
          setTenureYears={setTenureYears}
          emiValue={emiValue}
          totalInterest={totalInterest}
        />
      )}

      <div className="bg-white rounded-2xl shadow-[0_4px_16px_rgba(0,0,0,0.05)] p-2 flex items-center gap-2 mb-2">

        
        <div className="flex items-center gap-2 flex-grow">
          <input
            type="text"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            onKeyPress={onKeyPress}
            disabled={disabled}
            aria-label="Type your message"
            placeholder={placeholder}
            className="flex-grow outline-none text-sm text-gray-900 placeholder:text-gray-500 bg-transparent disabled:opacity-50"
          />
        </div>
        
        <button
          onClick={onSendMessage}
          disabled={disabled || !inputText.trim()}
          className={`w-8 h-8 rounded-full flex items-center justify-center transition-colors ${
            inputText.trim() && !disabled
              ? "text-white bg-[#1a6ba0] hover:bg-[#005a8f]" 
              : "text-gray-400 bg-gray-200"
          }`}
          aria-label="Send message"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 19V5M12 5L5 12M12 5L19 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
      

    </>
  );
};

export default InputArea;

